/* eslint-disable @wordpress/dependency-group */
import $ from 'jquery';

const triggerQuantityChange = () => {
	$( '.quantity' ).each( function () {
		const qtyInputWrapper = $( this ),
			addCartButton = qtyInputWrapper.next( '.add_to_cart_button' ),
			input = qtyInputWrapper.find( 'input[type="number"]' ),
			btnUp = qtyInputWrapper.find( '[rel="qty-increase"]' ),
			btnDown = qtyInputWrapper.find( '[rel="qty-decrease"]' ),
			addToCartBtn = qtyInputWrapper
				.parent()
				.siblings( '.product-add-to-cart' )
				.children( '.add_to_cart_button' );

		input.on( 'change', function () {
			const min = input.attr( 'min' ) || 1,
				max = input.attr( 'max' ) || 999,
				oldValue = parseFloat( input.val() ),
				newVal =
					// eslint-disable-next-line no-nested-ternary
					oldValue < min
						? min
						: oldValue > parseFloat( max )
						? max
						: oldValue;

			$( this ).val( newVal );
			// console.log( { newVal, max: +max } );
			// if ( newVal > +min ) {
			if ( newVal > 1 ) {
				if ( btnDown.hasClass( 'disabled' ) ) {
					btnDown.removeClass( 'disabled' );
				}
			} else {
				btnDown.addClass( 'disabled' );
			}
			if ( newVal >= +max ) {
				btnUp.addClass( 'disabled' );
			} else if ( btnUp.hasClass( 'disabled' ) ) {
				btnUp.removeClass( 'disabled' );
			}
			addCartButton.attr( 'data-quantity', newVal );
			$( '.woocommerce-cart-form :input[name="update_cart"]' ).prop(
				'disabled',
				false
			);
		} );

		input.on( 'keyup', function ( event ) {
			const targetEl = event.target;
			const inputValue = +targetEl.value;
			const cartBtn = targetEl.offsetParent.querySelector(
				'.single_add_to_cart_button'
			);
			const up = targetEl.parentNode.querySelector(
				'[rel="qty-increase"]'
			);
			const down = targetEl.parentNode.querySelector(
				'[rel="qty-decrease"]'
			);
			const min = $( targetEl ).attr( 'min' ) || 1,
				max = $( targetEl ).attr( 'max' ) || 999;

			if ( inputValue >= +max ) {
				up.classList.add( 'disabled' );
			} else {
				up.classList.remove( 'disabled' );
			}
			// console.log( { inputValue, min, max } );
			if ( inputValue <= +min ) {
				down.classList.add( 'disabled' );
			} else {
				down.classList.remove( 'disabled' );
			}
			if ( inputValue >= +max ) {
				cartBtn.classList.add( 'disabled' );
			} else {
				cartBtn.classList.remove( 'disabled' );
			}
			if ( event.key === 'Enter' ) {
				const maxQty = input.attr( 'max' );
				if ( inputValue >= +maxQty ) {
					event.target.value = maxQty;
					// console.log( maxQty, cartBtn );
					// cartBtn.classList.remove( 'disabled' );
				}
			}
			qtyInputWrapper.find( 'input' ).val( inputValue );
			addToCartBtn.attr( 'data-quantity', inputValue );
			qtyInputWrapper.find( 'input' ).trigger( 'change' );
		} );

		btnUp.click( function () {
			const max = input.attr( 'max' ) || 999,
				oldValue = parseFloat( input.val() );
			let newVal =
				oldValue >= max
					? oldValue
					: oldValue + parseFloat( input.attr( 'step' ) );
			if ( ! max ) {
				newVal = oldValue + parseFloat( input.attr( 'step' ) );
			}
			qtyInputWrapper.find( 'input' ).val( newVal );
			qtyInputWrapper.find( 'input' ).trigger( 'change' );
		} );

		btnDown.click( function () {
			const min = input.attr( 'min' ) || 1,
				oldValue = parseFloat( input.val() ),
				newVal =
					oldValue <= min
						? oldValue
						: oldValue - parseFloat( input.attr( 'step' ) );

			qtyInputWrapper.find( 'input' ).val( newVal );
			qtyInputWrapper.find( 'input' ).trigger( 'change' );
		} );
	} );
};

export default triggerQuantityChange;
